"use client";
import React from "react";
import AboutSection from "./_components/AboutSection";

const page = () => {
  return (
    <main className="bg-[#FFFFFFE6] flex flex-col items-center w-full min-h-screen">
      <div className="bg-[#FFFFFFE6] w-full max-w-[1440px]">
        <AboutSection />
      </div>
    </main>
  );
};

export default page;
